// Note : l'ordre d'affichage des catégories de recherche est dérivé
// alphabétiquement du libellé (defaultMessage) au moment de l'assemblage
// dans BottomHeader (_.sortBy sur defaultMessage). Pas de champ `index` à
// maintenir : ajouter une catégorie = ajouter la constante, sa place se calcule seule.

export const SUBCONTRACTOR_SEARCH_TAG = [
  {
    translationId: "subcontractors",
    defaultMessage: "Sous-traitants",
    active: false,
    value: "str",
  },
];

export const STAFF_SEARCH_TAG = {
  translationId: "staff",
  defaultMessage: "Staff",
  active: false,
  value:
    "rdd,ads,adv,radv,gp,rgp,mgr,dsoc,si,ada,rh,sec,dfin,dg,pdt,ia,rbu,dsi,cdc,cge,law,asr,wyo,climate,rd,fin,clrz,twi,forma,itny,rada,rfin",
};

export const PARTNER_STR_COMPANY_SEARCH_TAG = {
  translationId: "partner_subcontractor_company",
  defaultMessage: "Société sous-traitante (portage salarial)",
  active: false,
  value: "subcontractor_company",
  isPartnerConnection: true,
};

export const STR_COMPANY_SEARCH_TAG = {
  translationId: "subcontractor_company",
  defaultMessage: "Société sous-traitante",
  active: false,
  value: "subcontractor_company",
};

export const CLIENT_SEARCH_TAG = {
  translationId: "customers",
  defaultMessage: "Clients",
  active: false,
  value: "client",
};

export const BILLING_COMPANY_SEARCH_TAG = {
  translationId: "billing_client",
  defaultMessage: "Société de facturation",
  active: false,
  value: "billing_client",
};

// TODO HF-0250 : filtre front en place mais non fonctionnel tant que le
// backend ne renvoie pas de résultats `user_type: "contact"` (entité Contact
// + SearchProfile::Contact à implémenter côté back). La valeur "contact" est
// absorbée sans erreur par le back (ProfileId::Other) → 0 résultat, pas de 400.
export const CONTACT_SEARCH_TAG = {
  translationId: "contact",
  defaultMessage: "Contact",
  active: false,
  value: "contact",
};

export const ALL_SEARCH_TAG = {
  translationId: "all",
  defaultMessage: "Tout",
  active: true,
};

export const CONSULTANTS = {
  translationId: "cslt",
  defaultMessage: "Consultants",
  active: false,
  value: "cslt",
};
